module.exports = __webpack_public_path__ + "img/user-demo.2f225a57.png";